export interface SessionFilter {
  field: SessionFilterField;
  comparator: SessionFilterComparator;
  value: any;
  key?: string;
  metric?: FeedbackScoreSessionMetric;
}

export interface IncompleteSessionFilter {
  field?: SessionFilterField;
  comparator?: SessionFilterComparator;
  value?: any;
  key?: string;
  metric?: FeedbackScoreSessionMetric;
}

export enum SessionFilterField {
  FEEDBACK_SCORE = 'feedback_score',
  METADATA = 'metadata',
  NAME = 'name',
}

export enum FeedbackScoreSessionMetric {
  AVERAGE = 'average',
}

export enum SessionFilterComparator {
  // For feedback
  EQ = 'eq',
  NEQ = 'neq',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',

  // For metadata
  EXISTS = 'exists',
}

export const allowedSessionFeedbackComparators: SessionFilterComparator[] = [
  SessionFilterComparator.EQ,
  SessionFilterComparator.NEQ,
  SessionFilterComparator.GT,
  SessionFilterComparator.GTE,
  SessionFilterComparator.LT,
  SessionFilterComparator.LTE,
];

export const allowedSessionMetadataComparators: SessionFilterComparator[] = [
  SessionFilterComparator.EXISTS,
];
